module.exports = __webpack_public_path__ + "d87781dfd57f5b1a28c1338ae7c4366c.mp3";